import { useNavigate } from 'react-router-dom';

function Button(props) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(props.link)}
      className="flex flex-col items-center gap-3 rounded-2xl"
    >
      <div className={`${props.color} p-3 rounded-xl`}>
        <props.icon className="w-6 h-6 text-white" />
      </div>
      <span className="text-sm font-medium">{props.label}</span>
    </button>
  );
}

export default Button;
